import { memoize } from 'lodash';
import { localeService } from '../../core';
import { StreamType } from '../constants';
export const getParticipantScreenName = memoize((name, streamType) => {
    return streamType === StreamType.Screen
        ? localeService.formatMessageById('video-chat.screen-sharing.name-with-suffix', { name: name })
        : name;
}, (...args) => args.join('-'));
